'use client';

import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '~/GlobalRedux/store';

const initialState: boolean = true;

const expandSlice = createSlice({
  name: 'expand',
  initialState,
  reducers: {
    setExpand: (_state, action: PayloadAction<boolean>) => {
      return action.payload;
    },
  },
});

export const { setExpand } = expandSlice.actions;
export default expandSlice.reducer;
export const expandSelector = (state: RootState) => state.expand;
